var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fa-2x",class:("icon-" + (this.iconName || 'Car0')),style:({color: _vm.iconColor, width: (_vm.iconWidth + "px"), height: (_vm.iconHeight + "px"), lineHeight: (_vm.iconHeight + "px"), fontSize: (_vm.iconHeight + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }